// Pure trailer rules. No I/O, no Deno APIs, so the browser can import them too.

/** Escape LIKE wildcards so an ILIKE is an exact case-insensitive match. */
export function likeExact(value: string): string {
  return value.replace(/[\\%_]/g, (c) => `\\${c}`);
}
